import "./scss/GLSDk.scss";
import "./css/leaflet.css";

import WooCommerce from "./js/GLSDk-woo-commerce.js";
import GLSDkWidget from "./js/GLSDk-widget";

/**
 * Class GLSDk depends on jQuery.
 * Check if we are meant to append a map
 *
 * Platform dependent functions marked with   * @platformDependent
 */
class GLSDk {
  constructor(ajax_url) {
    this.markers = []; //pickup {lat, lng}
    this.isMapLoaded = false;
    this.gmaps_key =
      typeof GLSDk_maps_key == "undefined" ? "" : GLSDk_maps_key;
    this.openMapMarkerIcons = {};
    this.ajax_url = ajax_url; // platform dependent

    // ✅ Track if scripts are preloading
    this.scriptsPreloaded = false;
    this.addressPreGeocoded = false;

    this.platform = new WooCommerce(this.ajax_url);

    this.platform.isCheckout();
    this.init();
  }

  init() {
    this.GLSDkWidget = new GLSDkWidget({
      host: "https://GLSDk.me",
      address: this.platform.getShippingData().Address,
      labels: {},
      mapParentContainer: "body",
      buttonParentContainer: "body",
      buttonClass: "",
      ajax_url: this.ajax_url,
      carrierId: this.platform.getShippingData().CarrierId,
      onPointSelected: () => {},
      gmapskey:
        typeof GLSDk_maps_key == "undefined" ? "" : GLSDk_maps_key,
    });
    this.GLSDkWidget.init();

    // ✅ Preload map resources in the background
    this.preloadMapResources();
  }

  /**
   * ✅ NEW: Preload map scripts and geocode address in background
   */
  preloadMapResources() {
    setTimeout(() => {
      // ✅ 1. Preload map scripts
      if (this.GLSDkWidget.mapinterface && !this.scriptsPreloaded) {
        this.scriptsPreloaded = true;

        if (jQuery("#sw").length === 0) {
          this.GLSDkWidget.addMapHtml();
        }
      }
    }, 2000);
  }
  /**
   * ✅ NEW: Pre-fetch pickup points in background
   */
  preFetchPickupPoints() {
    // Only if we have carrier ID and geocoded address
    if (
      !this.GLSDkWidget.carrier_id ||
      !this.GLSDkWidget.options.address.Lat
    ) {
      return;
    }

    const req = {
      Address: this.GLSDkWidget.options.address,
      CarrierId: this.GLSDkWidget.carrier_id,
      action: "GLSDk_pickup_locations",
    };

    jQuery
      .getJSON(this.ajax_url, req, (data) => {
        if (data && data.Point && data.Point.length > 0) {
          // ✅ Cache the results
          const cacheKey = this.GLSDkWidget.hashLatLng({
            lat: this.GLSDkWidget.options.address.Lat,
            lng: this.GLSDkWidget.options.address.Long,
          });

          this.GLSDkWidget.cacheResults[cacheKey] = data;
        }
      })
      .fail(() => {
        console.log("⚠️ Pre-fetch failed (not critical)");
      });
  }

  getPickupLocations(evt) {
    const carrierId =
      parseInt(jQuery("#shipping_carrier_id").val()) ||
      (window.GLSDkPickupManager &&
        window.GLSDkPickupManager.carrier_id);
    if (carrierId) {
      this.GLSDkWidget.carrier_id = carrierId;
      this.GLSDkWidget.setCarrierId &&
        this.GLSDkWidget.setCarrierId(carrierId);
    }
    // ✅ Remove any stale loaders before opening
    jQuery(".GLSDk-loader-btn").stop(true, true).remove();
    this.GLSDkWidget.openMap(); // openMap() handles its own loader
  }
}

jQuery(function () {
  if (typeof woocommerce_params != "undefined") {
    window.GLSDk = new GLSDk(woocommerce_params.ajax_url);
  }
});
